import React, {useState, useEffect} from 'react'
import {LoadEffect}  from '../component/loader'
import axios from 'axios'
import { Alerts} from '../component/notify'
import PageHeader from '../component/pageheader'
import {ServerUrl, Token, config, familyCode } from '../component/include'
import Select from 'react-select'

import { useSelector } from 'react-redux'
const PrintVoucher =()=> {
    const [errors, setErrors] = useState({});
    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    }); 
    
    const [voucher, setVoucher] = useState({
        feecharge:[],
        status:{value: 'ALL', label: 'ALL'},
        studentClass:[],
        voucherType:{ value: 'Bank', label: 'Bank Voucher' },
        slipNo:'',
        student:[]
    })
    const [studentList, setStudentList] = useState([]);
    const [feecharge, setFeecharge] = useState([]);
    const [bank, setBank]= useState([])

    const [result, setResult]=useState([])
    const [isSubmitting, setIsSubmitting] = useState(false);
   
    const fetchFeecharge =()=>{
        const fd = new FormData();
				  fd.append('jwt', Token);
        let url = ServerUrl+'/fetch_controller/tbl_fees_charge'
        axios.post(url, fd, config).then(result=>setFeecharge(result.data.filter(item=>item.status=='true')))
    }

  

    const  fetchPaymentGateway =()=>{
        const fd = new FormData();
				  fd.append('jwt', Token);
        let url = ServerUrl + '/fetchField/tbl_payment_gateway/details/title/Bank'
        axios.post(url, fd, config)
        .then(result => {
            setBank(result.data)
        })
        .catch((error)=>Alerts('Error!', 'danger', JSON.stringify(error.message))) 
            
    }


    const fetchStudents =()=>{
        setNotice({...notice, isLoading: true}) 
        var sql ="SELECT admissionNumber, registerNumber, studentName, classID, sectionID, code, fatherName, father_mobile from tbl_students where family_name = '"+familyCode+"'"
    
        const fd = new FormData();
        fd.append('jwt', Token);
    fd.append("sql", sql);
    let url = ServerUrl+'/fetchBySql_controller'
    axios.post(url, fd, config).then(result=>{
        
    setStudentList(result.data)
    })
    .catch((error)=>{
    Alerts('Error!', 'danger', error.message)
    }).finally(()=>{
        setNotice({...notice, isLoading: false})
        
    })
    }



    const handleSearch = event =>{
        event.preventDefault();    
        setErrors(ValidateErrors(voucher));
        setIsSubmitting(true);
    }  
    const ValidateErrors=(values)=>{
        let errors = {};   
        if(values.feecharge.length===0){
            errors.feecharge ='Please select fees';
        }  
        
        if(values.student.length===0){
            errors.student ='Please select student';
        } 

        return errors;
        }

    useEffect(()=>{
        if(Object.keys(errors).length === 0 && isSubmitting){
        fetchResult()
        }
        },[errors])

const handleSelect = (option, action)=>{
    setVoucher({...voucher, [action.name]: option });
   setErrors({...errors, [action.name]:''})
   setResult('')
}


const fetchResult =()=>{

if(voucher.voucherType.value ==='Blank'){
    window.open(ServerUrl+'/printout/fees_voucher_blank.php?token=kayus_token', '_blank')
}else{

    setNotice({...notice, isLoading: true}) 
    
var feecharge =voucher.feecharge.value
var vtype =voucher.voucherType.value
var status =''
var code = voucher.student.value
var slip = ''
var sectionID ='';


    var sql ="SELECT sf.ID, sf.classID, sf.sectionID, sf.payment_status, s.admissionNumber, s.registerNumber, s.studentName, s.mobile, CONCAT(f.sessionCode, ' ', f.feesCharge) as fees, sf.total,  (select sum(h.amount) from tbl_fees_payment_history h where h.scheduleCode =sf.code) as paid from tbl_students s, tbl_fees_charge f, tbl_student_fees sf  where s.code = sf.studentCode and f.code = sf.feeCharge and sf.feeCharge = '"+feecharge+"' and sf.studentCode ='"+code+"' order by sf.sectionID ASC"


    const fd = new FormData();
    fd.append('jwt', Token);
fd.append("sql", sql);
let url = ServerUrl+'/fetchBySql_controller'
axios.post(url, fd, config).then(result=>{
    if(result.data.length!==0){
setResult(result.data)

window.open(ServerUrl+'/printout/fees_voucher.php?feecharge='+feecharge+'&studentCode='+code+'&section='+sectionID+'&slip='+slip+'&status='+status+'&voucher='+vtype+'&token=fee_voucher', '_blank')


    }else{
        Alerts('Info!', 'info', 'There are no voucher found')
    }
})
.catch((error)=>{
Alerts('Error!', 'danger', error.message)
}).finally(()=>{
    setNotice({...notice, isLoading: false})
    
})
}
}




useEffect(()=>{
    fetchFeecharge()
    fetchStudents()
    fetchPaymentGateway()
},[]);

        return (  <>{notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
   <div  className="main-body">
                <div className="page-wrapper">
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title="Fees Voucher">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-money"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><a href="#!">Fees</a> </li>
                    <li className="breadcrumb-item"><a href="#!">Print Fees Voucher</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">

                <div className="row  no-print">
							

	<div className="col-sm-12">

    <div className="card z-depth-0">
		<div className="card-header">
			<h5><i className="fa fa-edit" ></i>Print Fees Voucher</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-maximizes full-card"></i></li>
					<li><i className="feather icon-minus minimize-card"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div><div className="card-block">
        <div className="card z-depth-0">
		<div className="card-block">
		<div className="row">
        <section className="col-md-4">
           <div className="form-group">
        
<label >Fee Charge<span style={{color:'red'}}>*</span> </label>
<Select  options={feecharge&&feecharge.map((list, idx)=> {
                               return {key:idx, value: list.code, label:list.feesCharge, session:list.sessionCode }
                             })
                        } 
                        getOptionLabel={option =>`${option.session}  ${option.label}`}       
onChange={handleSelect} className={errors.feecharge ? 'form-control form-control-danger' : ''} name="feecharge" value={voucher.feecharge}  />  
              <span style={{color:'red'}}>{errors.feecharge && errors.feecharge}</span> 
            </div>
     
     </section>      

     <section className="col-md-4">
									

        <div className="form-group">
                    <label>Search By Student </label>
                    <Select  options={
                        studentList.map((list, idx)=> {
                            return {key:idx, value: list.code, fatherName:list.fatherName, sectionID:list.sectionID, mobile:list.father_mobile, label: list.admissionNumber, studentName:list.studentName }
                            })} 
                    getOptionLabel={option =>option.label +' '+ option.studentName+' c/o '+option.fatherName+' '+option.mobile}

onChange={handleSelect}  name="student" value={voucher.student} 
className={errors.student ? 'form-control form-control-danger' : ''}  /> 

<span style={{color:'red'}}>{errors.student && errors.student}</span> 
                                        </div>

                            </section>
        	
     <section className="col-md-4">
           <div className="form-group">
           <label> Search By Voucher Type </label>
         <Select  options={[
                    { value: 'Bank', label: 'Bank Voucher' },
                    { value: 'Cash', label: 'Cash Voucher'},
					{ value: 'Blank', label: 'Blank Bank Voucher'}
                ]} 
			onChange={handleSelect}  name="voucherType" value={voucher.voucherType}  />
 <span style={{color:'red'}}>{errors.voucherType && errors.voucherType}</span>	
 
 </div>
     
     </section>

                        
                 <section className="col-md-12">  <div className="form-group">     <footer className="pull-right">
	
	<button type="button"  onClick={handleSearch} className="btn btn-danger "><i className="fa fa-bar-chart"></i> Search Voucher</button>
								</footer>	</div>
                                </section>

				</div>	

				
							</div>
                            </div>
							</div></div>
</div>

</div>
	

   </div>
          {/* The Page Body close here */}

            </div>
            </div>

</> 
 );
        
}

export default React.memo(PrintVoucher) 